// template lis
import {
  TEMPLATE_SUCCESS,
  DEFAULT_LOGO_SUCCESS,
  COMMON_REQUEST,
  COMMON_REQUEST_FAIL,
  STRIPE_PAYMENT_SUCCESS,
  RENDERS_PLAN_SUCCESS,
  CURRENT_PLAN_SUCCESS,
  SUBSCRIPTION_CANCELL_SUCCESS,
  NOTIFICATION_SUCCESS,
  OPTION_REQUEST,
  PROJECT_OPTION_SUCCESS,
  GLOBAL_COLOR_SUCCESS,
} from "./types";
import { getRequest, postRequest } from "../../services/axios";
export const allTemplatesList = () => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await getRequest(`/template`);
    const { data } = response?.data;
    dispatch({
      type: TEMPLATE_SUCCESS,
      payload: {
        data,
      },
    });
    return response?.data;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
export const getDefalutLogos = () => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest(`/project/getDefaultImages`);
    if (response?.data?.success) {
      let defaultLogos = [];
      // defaultLogos = [...response.data.users_logos];
      defaultLogos = [
        ...response.data.users_logos,
        ...response.data.formattedLogos,
      ];
      dispatch({
        type: DEFAULT_LOGO_SUCCESS,
        payload: defaultLogos,
      });
      return response?.data;
    } else {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error: response,
        },
      });
      return response;
    }
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const stripePayment =
  (token, product, coupanName) => async (dispatch) => {
    try {
      dispatch({ type: COMMON_REQUEST });
      let body = {
        token,
        product,
        coupanName,
      };
      const response = await postRequest(`/user/makeSubscription`, body);
      if (response?.status === 200) {
        dispatch({
          type: STRIPE_PAYMENT_SUCCESS,
          payload: {
            data: response?.data,
          },
        });
        dispatch(getCurrentPlan());
      } else {
        dispatch({
          type: COMMON_REQUEST_FAIL,
          payload: {
            error: response.error,
          },
        });
      }
      return response;
    } catch (error) {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };
export const applyCoupen = (coupanName) => async (dispatch) => {
  try {
    const response = await postRequest("/project/checkCoupanCodes", {
      coupanName,
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const getRendersPlan = (user) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest("/project/getPlans");

    if (response?.status === 200) {
      dispatch({
        type: RENDERS_PLAN_SUCCESS,
        payload: response?.data?.plans,
      });
    } else {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error: response.error,
        },
      });
    }
    return response;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
export const getCurrentPlan = (user) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest("/user/getUserPlan");
    if (response?.status === 200 && response.data.success) {
      dispatch({
        type: CURRENT_PLAN_SUCCESS,
        payload: response?.data,
      });
    } else {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error: response.error,
        },
      });
    }
    return response;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const CancellSubscription = (order_id) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest(`/user/cancelSubscription`, {
      order_id,
    });

    if (response?.status === 200) {
      dispatch({
        type: SUBSCRIPTION_CANCELL_SUCCESS,
        payload: {
          data: response?.data,
        },
      });
    } else {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error: response.error,
        },
      });
    }
    return response;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Skip Model
export const skipUserModel =
  ({ dashModalStatus, layoutModalstatus }) =>
  async () => {
    try {
      const response = await postRequest("/user/skipModal", {
        dashModalStatus,
        layoutModalstatus,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

// Option Selected

export const selectedOption = (isOptionSelected) => (dispatch) => {
  try {
    dispatch({ type: OPTION_REQUEST });
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: isOptionSelected,
    });
  } catch (error) {
    return error;
  }
};

//GLOBAL_COLOR_SUCCESS
export const setGlobalColorInReudx = (colorValue) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    dispatch({
      type: GLOBAL_COLOR_SUCCESS,
      payload: colorValue,
    });
  } catch (error) {
    return error;
  }
};

//notification
export const getNotification = () => async (dispatch) => {
  // pagination work remaining ******
  try {
    const response = await postRequest("/user/getNotification", {
      limit: 10,
      page_no: 1,
    });
    // console.log(response.data);
    dispatch({ type: COMMON_REQUEST });
    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_SUCCESS,
        payload: response.data,
      });
      return response.data.notifications;
    }
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const updateNotification = () => async (dispatch) => {
  try {
    const response = await postRequest("/user/updateNotification");
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const addNotifications =
  ({ project_id, render_id, message, status, user_id }) =>
  async (dispatch) => {
    try {
      const response = await postRequest("/user/addNotification", {
        project_id,
        render_id,
        message,
        status,
        user_id,
      });
      dispatch({ type: COMMON_REQUEST });
      if (response.data.success) {
        const res = await postRequest("/user/getNotification");
        dispatch({
          type: NOTIFICATION_SUCCESS,
          payload: res.data.notifications,
        });
      }
    } catch (error) {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const deleteNotifications =
  ({ notification_id }) =>
  async (dispatch) => {
    try {
      const response = await postRequest("/user/deleteNotification", {
        notification_id,
      });
      if (response.data.success) {
        const res = await postRequest("/user/getNotification", {
          limit: 10,
          page_no: 1,
        });
        dispatch({
          type: NOTIFICATION_SUCCESS,
          payload: res.data.notifications,
        });
      }
    } catch (error) {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const addSurvey = (answer) => async (dispatch) => {
  try {
    await postRequest("/user/addSurvey", { answer });
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const hasUserFilledSurvey = async () => {
  try {
    const response = await getRequest("/user/userFilledSurvey");
    if (response.data.success) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return error;
  }
};

export const userSeenTutorial = (status) => async (dispatch) => {
  try {
    await postRequest("/user/updateTutorialStatus", { status });
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// function to fetch all data for helpPage
export const getHelpPageData = () => async (dispatch) => {
  try {
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response  && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
